import { Controller } from "@hotwired/stimulus";

/**
 * Hides a banner and remembers dismissal in localStorage until `count` changes
 * (e.g. new declined/revoked collaborations), so users see the alert again when relevant.
 */
export default class extends Controller {
  static values = { bannerKey: String, count: Number };

  connect() {
    const stored = localStorage.getItem(this.storageKey);
    if (stored !== null && stored === String(this.countValue)) {
      this.element.classList.add("hidden");
    }
  }

  dismiss(event) {
    event.preventDefault();
    localStorage.setItem(this.storageKey, String(this.countValue));
    this.element.classList.add("hidden");
  }

  get storageKey() {
    return `idh-manage-invites-banner-${this.bannerKeyValue}`;
  }
}
